import { useState, useEffect } from "react";

// Hook version: for GET requests
export default function fetchData(url, options = {}) {
  const [data, setData] = useState(null);
  const [isError, setIsError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!url) return;
    setIsLoading(true);

    fetch(url, {
      headers: { "Content-Type": "application/json" },
      ...options,
    })
      .then(res => res.json())
      .then(setData)
      .catch(setIsError)
      .finally(() => setIsLoading(false));
  }, [url]);

  return { data, isLoading, isError };
}

// Utility function: for POST, PUT, DELETE (no hooks)
 
export async function sendRequest(url, method = "GET", body = null, extraOptions = {}) {
  try {
    const options = {
      method,
      headers: {
        "Content-Type": "application/json",
        ...(extraOptions.headers || {}),
      },
      ...extraOptions,
    };

    // only attach body if not GET or HEAD
    if (body && method !== "GET" && method !== "HEAD") {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);

    const contentType = response.headers.get("content-type");
    const responseData = contentType && contentType.includes("application/json")
      ? await response.json()
      : await response.text();

    if (response.ok) {
      return { done: true, data: responseData, isError: null };
    } else {
      return { done: false, data: null, isError: responseData };
    }
  } catch (err) {
    return { done: false, data: null, isError: err.message };
  }
}

